import { GLoading } from 'components/basic-blocks'
import { useUrlQuery } from 'hooks'
import { useEffect } from 'react'

/**
 * Shopify OAuth result page (DEV-2365). The backend callback finishes the secure exchange
 * server-side (HMAC + state nonce + code exchange + Web Pixel + metafields), then redirects the
 * popup here so the outcome lands *inside the app* and can be relayed to the ClickGUARD tab that
 * opened it — mirroring the Google/Bing OAuth pages. `status` is `connected`, `activate`, or `error`.
 */
export function ShopifyOAuthPage() {
	const query = useUrlQuery()

	useEffect(() => {
		if (query.status === 'error') {
			window.localStorage.setItem('shopify_oauth_error', query.reason || 'shopify_connect_failed')
		} else {
			window.localStorage.setItem('shopify_oauth_result', 'connected')
		}
		// Nudge the opener (ClickGUARD tab) to re-check immediately — the same signal the PPC pages use.
		if (window && window.opener) window.opener.dispatchEvent(new Event('beforeunload'))
		// Install (or the failure) is done — close the tab. Enabling the app-embed is a separate wizard
		// step now, so we never forward this tab to the theme editor.
		window.close()
	}, [])

	return (
		<div className="w-full h-full flex items-center justify-center">
			<GLoading />
		</div>
	)
}
